<script setup>
/**
 * Display a single message of the list of messages.
 */
import { defineProps } from "vue";
import { useFormatDateTime } from "@/../../common/utils/dateTime.js";
import AudioMessage from "./AudioMessage.vue";
import TextMessage from "./TextMessage.vue";

defineProps({
  message: Object,
  /**
   * Whether to mark external messages with a special label.
   */
  markExternal: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div style="display: flex">
    <i
      v-if="message.routing === 'sent'"
      class="fas fa-sign-out-alt fa-rotate-180 sy-arrow-in-out"
      :title="$t('common.t.outbound')"
    />
    <i
      v-else-if="message.routing === 'received'"
      class="fas fa-sign-in-alt sy-arrow-in-out"
      :title="$t('common.t.inbound')"
    />
    <div>
      <div class="w3-small">
        <em>{{
            $t(`date.at.${message.routing}`, [useFormatDateTime(message.timestamp)])
        }}</em>
      </div>
      <AudioMessage
        v-if="message?.type === 'audio'"
        :message="message"
      />
      <TextMessage
        v-else
        :message="message"
      />
    </div>
  </div>
</template>

<style lang="scss">
.sy-arrow-in-out {
  margin: 0 0.25rem 0 -1.25rem;
  align-self: flex-start;
  color: var(--theme-l2);
}
</style>
